
import requestAPI from '@/logic/requestBeApi';

export default {
  name: 'UserRow',

  props: {
    profile: {
      type: String,
      required: false,
      default: '',
    },
    switchOption: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      required: true,
    },
    location: {
      type: String,
      default: '',
    },
    industries: {
      type: String,
      default: '',
    },
    rating: {
      type: Number,
      default: 0,
    },
    match: {
      type: String,
      default: '',
    },
    avatarUrl: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
    clientCompany: {
      type: String,
      default: '',
    },
    reportDate: {
      type: String,
      default: '',
    },
    assessorId: {
      type: String,
      default: '',
    },
    userId: {
      type: String,
      default: '',
    },
    assessmentRequestId: {
      type: String,
      default: '',
    },
    assessorStatus: {
      type: String,
      default: '',
    },
    assessorInterestedText: {
      type: String,
      default: '',
    },
    assessorDeclinedText: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    candidateId: {
      type: String,
      default: '',
    },
    profileComplete: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Boolean,
      default: false,
    },

    canRedirectToProfile: Boolean,
    switchOn: Boolean,
    displayPingAssessorButton: Boolean,
    appendRecentlyAddedCandidatesToTheProject: Boolean,
    chooseOnlyOneUser: Boolean,
    userRole: {
      type: String,
      default: '',
    },
  },

  data(): Record<string, unknown> {
    return {
      reinvitationPending: false,
      assessorReinvited: false,
      switchStateEmitted: false,
    };
  },

  computed: {
    statusIconClass() {
      return {
        'el-icon-warning': !this.profileComplete,
        'icon-blue': !this.profileComplete,
        'g-pulse-animation': !this.profileComplete,
        'el-icon-success': this.profileComplete,
        'icon-gray': this.profileComplete,
      };
    },

    switched: {
      get(): boolean {
        return this.switchOn || false;
      },

      set(newVal: boolean): boolean {
        return newVal;
      },
    },
    isClientReadOnly(): boolean {
      return localStorage.getItem('clientRoleType') === 'clientReadOnly';
    },

    determineAvatarSize(): string {
      if (this.profile === 'Candidate' && this.clientCompany && this.reportDate)
        return 'width: 4rem; height: 4rem;';
      else return 'width: 2.5rem; height: 2.5rem;';
    },

    switchId(): string {
      return `${this.userName.toLowerCase().replaceAll(' ', '_')}-${this.assessorId ||
        this.candidateId}`;
    },
  },

  watch: {
    appendRecentlyAddedCandidatesToTheProject(): void {
      if (this.appendRecentlyAddedCandidatesToTheProject) {
        this.appendRecentlyAddedCandidate();
      }
    },
  },

  mounted(): void {
    this.attachAvatar();
    this.assessorReinvited = !this.displayPingAssessorButton;
  },

  methods: {
    attachAvatar(): void {
      const styleEl = document.head.appendChild(document.createElement('style'));
      styleEl.innerHTML = `.user-row-switch-${
        this.switchId
      } .el-switch__core::after {background: url(${this.avatarUrl}),
      url(${require('@/assets/default-avatar.png')})}`;
    },

    emitEvents(event: { stopPropagation: () => void }): void {
      event.stopPropagation();

      this.$emit('catchClickedUserID', this.userId);

      if (this.userRole) {
        this.$emit('redirectAccordingToPassedUserRole', this.userRole, this.userId);
        return;
      }

      if (!this.switchOption || (this.switchOption && this.chooseOnlyOneUser)) {
        if (this.profile === 'Assessor' && !this.switchStateEmitted)
          this.$emit('seeAssessorProfile');
        if (this.profile === 'Candidate') this.$emit('seeCandidateProfile');
      }
    },

    emitSwitchState(): void {
      if (
        localStorage.getItem(this.candidateId) === 'recentlyAddedCand' &&
        this.profile === 'Candidate'
      ) {
        localStorage.removeItem(this.candidateId);
      }

      this.$emit('emitSwitchState');
      this.switchStateEmitted = true;

      setTimeout(() => {
        this.switchStateEmitted = false;
      }, 500);
    },

    displayMatch(match: string): number {
      return Math.round(parseInt(match) / 10);
    },

    async reinviteAssessor(event: { stopPropagation: () => void }): Promise<void> {
      event.stopPropagation();
      if (this.assessorReinvited) return;

      this.reinvitationPending = true;

      const resp = await requestAPI({
        method: 'POST',
        url: `/api/v1/assessors/${this.assessorId}/request-reminder/${this.assessmentRequestId}`,
      });

      if (resp.ok) {
        this.assessorReinvited = true;
        this.$message.success(`${this.userName} ${this.$t('hasBeenReinvited')}.`);
      } else if (resp.status !== 401) {
        this.$message.error(this.$t('someErrorOccurred'));
      }

      this.reinvitationPending = false;
    },

    appendRecentlyAddedCandidate(): void {
      if (localStorage.getItem(this.candidateId) === 'recentlyAddedCand' && !this.switchOn) {
        this.switched = true;
        this.$emit('emitSwitchState');
      }
    },
  },
};
